/* Screedworks Custom JS — Category Dropdown */
document.addEventListener('click', function(e) {
  var opt = e.target.closest('.js-product-types.nice-select .option');
  if (!opt) return;
  var url = opt.getAttribute('data-value');
  if (url && url.startsWith('/collections')) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }
});


/* Screed Works 2026-10-20: sticky add to cart bar shows the same price format as the product page
   (ex VAT first, inc VAT in brackets). The theme copies only the ex VAT figure into the bar. */
(function () {
  function syncStickyPrice() {
    var bar = document.querySelector('#sticky-cta .sticky-cta__price');
    var main = document.querySelector('.product__info-wrapper .price__container');
    if (!bar || !main) return;
    var onSale = main.closest('.price') && main.closest('.price').classList.contains('price--on-sale');
    var box = main.querySelector(onSale ? '.price__sale' : '.price__regular') || main;
    var ex = box.querySelector('.price-item--sale, .price-item--regular');
    var inc = box.querySelector('.price-item--vat');
    if (!ex) return;
    var html = ex.textContent.trim().replace(/\s+/g, ' ');
    if (inc) html += ' <span class="sw-inc-vat">' + inc.textContent.trim() + '</span>';
    if (bar.innerHTML !== html) bar.innerHTML = html;
  }
  document.addEventListener('DOMContentLoaded', function () {
    syncStickyPrice();
    var bar = document.querySelector('#sticky-cta .sticky-cta__price');
    if (bar) new MutationObserver(function () { setTimeout(syncStickyPrice, 50); }).observe(bar, { childList: true, characterData: true, subtree: true });
    var info = document.querySelector('.product__info-wrapper');
    if (info) new MutationObserver(function () { setTimeout(syncStickyPrice, 50); }).observe(info, { childList: true, subtree: true });
  });
})();
